<app-dialog-container
    [loading]="false"
    (closeEvent)="closeDialogFalse()"
    [title]="'Configure Emailed Report'"
    data-cy="load-email-report-dialog-container"
>
    <div class="ra-primary-blue has-text-centered label-wrapper">
        <label class="has-text-weight-semibold">Configure Emailed Report</label>
    </div>

    <app-filter-input [property]="toggleSwitch"></app-filter-input>

    <ng-container *ngIf="toggleSwitch.Value">
        <app-filter-input
            *ngIf="frequencyFilter"
            [property]="frequencyFilter"
        ></app-filter-input>
        <app-filter-input
            *ngIf="isMonthly"
            [property]="firstDayOfTheMonth"
        ></app-filter-input>
        <app-filter-input
            *ngIf="isMonthly && !firstDayOfTheMonth.Value"
            [property]="weekOfMonth"
        ></app-filter-input>
        <app-filter-input
            *ngIf="isWeekly || (isMonthly && !firstDayOfTheMonth.Value)"
            [property]="dayOfWeekFilter"
        ></app-filter-input>
        <app-filter-input
            *ngIf="isDaily || isWeekly || isMonthly"
            [property]="timeFilter"
        ></app-filter-input>
        <app-filter-input [property]="endDateFilter"></app-filter-input>
        <app-filter-input
            *ngIf="isPoliticalLur"
            [property]="excludePastWeeks"
        ></app-filter-input>
        <app-button
            [class]="'margin'"
            [buttonText]="'Send One-Time Report'"
            (buttonClick)="sendOneTimeReport()"
            [type]="'text'"
            [disabled]="isSendingReport ? 'true' : null"
        />

        <div *ngIf="isDaily">
            <mat-radio-group
                [(ngModel)]="dailyOption"
                (change)="updateDayOfWeek()"
            >
                <mat-radio-button
                    class="margin-top-75-em margin-bottom-1-em"
                    [value]="dailyOptions.mondayToFriday"
                >
                    Monday to Friday
                </mat-radio-button>
                <mat-radio-button
                    class="margin-top-75-em margin-bottom-1-em"
                    [value]="dailyOptions.everyday"
                >
                    Everyday
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div class="delivery-settings">
            <div class="settings-header">
                <i class="fas fa-envelope"></i>
                <div>
                    <p class="settings-title">Delivery Settings</p>
                    <p
                        *ngIf="userIds.length === 1"
                        class="settings-subtitle"
                    >
                        Report will be emailed to your account
                    </p>
                </div>
            </div>
            <div
                *ngIf="config.roleCapability.rate_optics.general.email_report_to_others"
                class="is-flex is-flex-direction-column"
            ></div>
            <div
                *ngIf="userIds.length > 1"
                class="is-flex align-center"
            >
                <i class="fas fa-user margin-right-half-em"></i>{{ userIds.length }} Users Selected
            </div>
            <app-button
                *ngIf="config.roleCapability.rate_optics.general.email_report_to_others"
                [buttonText]="'Add' + (userIds.length > 1 ? '/Edit' : '') + ' Additional Recipients'"
                [icon]="'fas fa-users margin-right-half-em'"
                (buttonClick)="openSelectRecipients()"
                [type]="'text'"
                [class]="'recipients-button'"
            />
        </div>
    </ng-container>
    <div
        *ngIf="!toggleSwitch.Value"
        class="disabled-message"
    >
        This report is disabled
    </div>
    <div class="level-right">
        <app-button
            [ngClass]="{ 'disabled-save': !validateFilters() }"
            [buttonText]="'Save'"
            (buttonClick)="onSaveFilters()"
            [type]="'flat'"
            [disabled]="!validateFilters() ? 'true' : null"
        />
    </div>
</app-dialog-container>
